import styled from "styled-components";

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 20rem auto;
  padding: 2rem 0;
  gap: 2rem;
`;

export const IconContainer = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  gap: 1rem;
`;
